import React, { useEffect } from 'react';

const ChatSalesForce = () => {
  const {
    REACT_APP_SALES_FORCE_BASE_URL,
    REACT_APP_SALES_FORCE_BASE_LIVE_AGENT_CONTENT_URL,
    REACT_APP_SALES_FORCE_BASE_LIVE_AGENT_URL,
    REACT_APP_SALES_FORCE_URL_INIT,
    REACT_APP_SALES_FORCE_URL_CENTRAL_AJUDA,
    REACT_APP_SALES_FORCE_ENVIRONMENT_ID,
  } = process.env;

  const settings = () => ({
    displayHelpButton: true,
    language: 'pt-BR',
    defaultMinimizedText: 'Atendimento Chat',
    disabledMinimizedText: 'Chat Offline',
    offlineSupportMinimizedText: 'Chat Offline',
    loadingText: 'Carregando',
    prepopulatedPrechatFields: {
      SuppliedName: 'Bunda Cagada',
      FirstName: 'Bunda Cagada',
      LastName: '',
      SuppliedEmail: 'bndacagada@gmail.com',
      Subject: '',
    },
    targetElement: document.getElementById('chat_sf_placeholder'),
    enabledFeatures: ['LiveAgent'],
    entryFeature: 'LiveAgent',
  });

  const initESW = (gslbBaseURL) => {
    window.embedded_svc.settings = Object.assign(window.embedded_svc.settings, settings());
    window.embedded_svc.init(
      REACT_APP_SALES_FORCE_URL_INIT,
      REACT_APP_SALES_FORCE_URL_CENTRAL_AJUDA,
      gslbBaseURL,
      REACT_APP_SALES_FORCE_ENVIRONMENT_ID,
      'CS_Pri_Chat',
      {
        baseLiveAgentContentURL: REACT_APP_SALES_FORCE_BASE_LIVE_AGENT_CONTENT_URL,
        deploymentId: '5720H000000W7jS',
        buttonId: '5730H000000WBzq',
        baseLiveAgentURL: REACT_APP_SALES_FORCE_BASE_LIVE_AGENT_URL,
        eswLiveAgentDevName: 'CS_Pri_Chat',
        isOfflineSupportEnabled: true,
      },
    );
  };

  useEffect(() => {
    if (window.embedded_svc) {
      initESW(REACT_APP_SALES_FORCE_BASE_URL);
    }
  });

  return <div id="chat_sf_placeholder" />;
};

export default ChatSalesForce;
